import { router } from '@inertiajs/vue3'

import type { ActionCategory } from '@/domains/command-center/types'

const getQuickUpdateCategory = (): ActionCategory => ({
  id: 'cat-quick-updates',
  label: 'Quick Updates',
  // A new quick update sits inside the Inventory section and changes stock, so its route asks for
  // both. A role with one of the two would meet a 403.
  permission: [
    { action: 'view', subject: 'inventory' },
    { action: 'adjust', subject: 'inventory.stock' }
  ],
  actions: [
    {
      id: 'action-quick-update-new',
      type: 'action',
      label: 'New Quick Update',
      icon: 'bolt',
      keywords: ['new', 'create', 'quick', 'update', 'inventory', 'adjust', 'stock', 'count'],
      execute: () => router.get(route('admin.inventory.quick-updates.new')),
      onSuccess: 'closeMenu'
    }
  ]
})

export { getQuickUpdateCategory }
